import { QueryKeys } from "@/data/globals";
import { CmsItemMarkdown } from "@/prisma/generated/browser";
import { useQuery } from "@tanstack/react-query";

export default function useCmsMarkdownItems() {
  const query = useQuery<CmsItemMarkdown[]>({
    queryKey: [QueryKeys.CMS_ITEMS_MARKDOWN],
    queryFn: async () => {
      const res = await fetch("/api/cms/items/markdown");
      return (await res.json()) as CmsItemMarkdown[];
    }
  });

  return query;
}
